import { ContactEntity } from '../contact';
import { Entity } from '../entity';


export enum ServiceConnectionType {
    Xero = 'Xero',
    Myob = 'Myob',
    QuickBooks = 'QuickBooks',
    WorkBuddy = 'WorkBuddy Connect',
    Stripe = 'Stripe',
    What3Words = 'What3Words',
    SMS = 'SMS',
    OpenAI = 'OpenAI',
    PropertyMe = 'PropertyMe',
    PropertyTree = 'PropertyTree',
    PropertyMeCustomer = 'PropertyMeCustomer',
    PropertyTreeCustomer = 'PropertyTreeCustomer',
    AddressValidation = "Address Validation",
    SchedulingAutomation = 'SchedulingAutomation',
    Jobpac = 'Viewpoint Jobpac Connect',
    Anthropic = 'Anthropic',
    HomesNSW = 'HomesNSW'
}


export interface ServiceConnectionSummary {
    _id: string;
    name: string;
    type: ServiceConnectionType;
    authenticated: boolean;
    email: string;
    expires: Date;
    tenants: Entity[];
    entity?: Entity | ContactEntity;
    settings?: { [key: string]: any }
    data?: any;
}

export interface PropertyMeConnectionSettings {
    tenantTags?: Entity[],
    propertyManagerTags?: Entity[]
}

export interface ServiceConnection extends ServiceConnectionSummary {
    tokens: any;
}

export interface ServiceConnectionStartAuthenticationResponse {
    success: boolean;
    authUrl: string;
    item: ServiceConnectionSummary;
    error?: any;
}


export interface ServiceConnectionTokenInfo {
    serviceConnectionId: string;
    tenants: Entity[];
    tokens: any;
    email: string;
    expiry: Date;
}

export interface ServiceConnectionInfo {
    _id: string;
    tenant: Entity;
}

export interface ServiceConnectionKeySecretToken {
    provider: string;
    key: string;
    secret: string;
    endpoint: string;
    orgId: string;
}